import { useNavigate } from "react-router-dom";
import { PageHeader } from "../../components/ui";
import { EventListDV } from "../../components";

export const Events = () => {
  const navigate = useNavigate();

  return (
    <div className="p-card gap-4 p-3">
      <PageHeader title="Eventos" onCreate={() => navigate("new")} createLabel="Crear evento" />
      <EventListDV />
    </div>
  );
};
